import React, { useCallback, useEffect, useRef, useState } from 'react';

import '../styles/components/ImageCarousel.css';

type CarouselProps = {
  items: any[]; 
   slideInterval?: number;
};

const Carousel: React.FC<CarouselProps> = ({ items, slideInterval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const clearSlideInterval = useCallback(() => {
    if (slideInterval === 0) {
      return;
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [slideInterval]);

  const startSlideInterval = useCallback(() => {
    if (slideInterval === 0) {
      return;
    }

    clearSlideInterval();
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === items.length - 1 ? 0 : prevIndex + 1
      );
    }, slideInterval);
  }, [slideInterval, clearSlideInterval, items.length]);

  const prev = () => {
    clearSlideInterval();
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? items.length - 1 : prevIndex - 1
    );
    startSlideInterval();
  };

  const next = () => {
    clearSlideInterval();
    setCurrentIndex((prevIndex) =>
      prevIndex === items.length - 1 ? 0 : prevIndex + 1
    );
    startSlideInterval();
  };

  useEffect(() => {
    startSlideInterval();
    return clearSlideInterval;
  }, [slideInterval, clearSlideInterval, startSlideInterval]);

  return (
    <div className="carouselContainer">
      {items[currentIndex]}
      <button className="carouselButton left" onClick={prev}>
        &#8249;
      </button>
      <button className="carouselButton right" onClick={next}>
        &#8250;
      </button>
    </div>
  );
  
};

export default Carousel;
